export default __webpack_public_path__ + "static/media/freya-silver.ae66d201.png";